import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import {
  ListingResource,
  MediaField,
  PropertyField as Field,
} from '../../system/field';
import { MediaCategory, MediaResource } from '../../system/media';
import { toHTTPSURL } from '../../utils';

interface PublishConfirmationProps {
  getResourceValue: (
    resourceType: ListingResource,
    fieldName: string,
    fallbackValue: any,
  ) => string;
  getMediaByCategory: (...category: MediaCategory[]) => MediaResource[];
  onListingsClick: () => void;
}

const PublishConfirmation: React.FC<PublishConfirmationProps> = ({
  getResourceValue,
  getMediaByCategory,
  onListingsClick,
}) => {
  const address = getResourceValue(
    ListingResource.Property,
    Field.FULL_STREET_ADDRESS,
    'Not Set',
  );
  const listingId = getResourceValue(
    ListingResource.Property,
    Field.LISTING_ID,
    'Not Set',
  );
  const photos = getMediaByCategory(MediaCategory.Photo) as any;

  const mainImage = photos.sort(
    (photoA: any, photoB: any) =>
      photoA[MediaField.MEDIA_DISPLAY_ORDER] -
      photoB[MediaField.MEDIA_DISPLAY_ORDER],
  )[0];

  const listingPhoto = mainImage
    ? toHTTPSURL(mainImage[MediaField.MEDIA_URL_HI_RES])
    : null;

  return (
    <Box
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 600,
      }}
    >
      <Typography variant="body1" sx={{ color: '#1A1A1E' }}>
        The following listing has been successfully published:
      </Typography>

      <Box
        sx={{
          width: '100%',
          aspectRatio: '4/3',
          bgcolor: '#F5F5F5',
          overflow: 'hidden',
          borderRadius: 1,
        }}
      >
        {listingPhoto ? (
          <img
            src={listingPhoto}
            alt={address}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: '#F5F5F5',
              color: '#767678',
            }}
          >
            <Typography variant="body1">No Photo Set</Typography>
          </Box>
        )}
      </Box>

      <Typography sx={{ fontWeight: 700, mt: 2 }}>{address}</Typography>

      <Typography sx={{ fontWeight: 500, mt: 1 }}>MLS# {listingId}</Typography>

      <Button
        variant="contained"
        onClick={onListingsClick}
        sx={{
          mt: 2,
          bgcolor: '#F13C00',
          '&:hover': {
            bgcolor: '#d63600',
          },
          textTransform: 'none',
        }}
      >
        Go To My Listings
      </Button>
    </Box>
  );
};

export default PublishConfirmation;
